// extracted by mini-css-extract-plugin
module.exports = {"video":"video_video___nDSH","desktopVideo":"video_desktopVideo__F__dx","mobileVideo":"video_mobileVideo__Zu_GD"};